import type { IQueueFrame } from '@/types'

function mainFacetAssetUrn(frame: Pick<IQueueFrame, 'facets'>): string {
  return frame.facets?.main?.asset?.trim() ?? ''
}

/** True when the next row should continue the same main asset (portal CPS slot split or explicit link). */
export function shouldSeamlesslyContinueFromPreviousFrame(
  previous: Pick<IQueueFrame, 'facets' | 'playContinuousWithNext'>,
  next: Pick<IQueueFrame, 'facets'>
): boolean {
  if (previous.playContinuousWithNext === true) {
    return true
  }
  const prevAsset = mainFacetAssetUrn(previous)
  const nextAsset = mainFacetAssetUrn(next)
  return prevAsset !== '' && prevAsset === nextAsset
}

/**
 * Seconds into the facet's main asset to start at when this queue row continues the same
 * video/image run as the immediately preceding row(s) (portal CPS slot splits, `playContinuousWithNext`).
 */
export function continuousMediaOffsetSecondsForQueueFrame(
  queue: readonly IQueueFrame[],
  frame: Pick<IQueueFrame, 'id' | 'facets'>
): number {
  const assetUrn = frame.facets?.main?.asset?.trim() ?? ''
  if (assetUrn === '') {
    return 0
  }
  const idx = queue.findIndex(q => q.id === frame.id)
  if (idx <= 0) {
    return 0
  }
  let offset = 0
  for (let i = idx - 1; i >= 0; i--) {
    const prev = queue[i]!
    const prevAsset = prev.facets?.main?.asset?.trim() ?? ''
    if (prevAsset !== assetUrn) {
      break
    }
    offset += prev.duration
  }
  return offset
}
